/**
 * The title, with clamping as an explicit decision.
 *
 * `lines` is required and `Full` is a first-class member rather than the
 * absence of a value, because "no clamp" and "nobody thought about it" are
 * different intentions that used to look identical in a props list. Detail and
 * expanded compositions may only pass `Full`: a detail tier that clamps the
 * name of the thing it is about is the defect this contract exists to prevent.
 */
"use client";
import type { ReactElement, ReactNode } from "react";
import { CRC_TYPE_STYLE, crcTextClampStyle } from "./cresultcard.tokens";
import { CresultcardTextStep, CresultcardTitleLines } from "./cresultcard.types";

interface CresultcardTitleProps {
  readonly children: ReactNode;
  readonly lines: CresultcardTitleLines;
  /** The lead step for a detail's own name; the title step everywhere else. */
  readonly step?: CresultcardTextStep.Title | CresultcardTextStep.Lead;
}

export function CresultcardTitle({
  children,
  lines,
  step = CresultcardTextStep.Title,
}: CresultcardTitleProps): ReactElement {
  return (
    <span
      data-el="Cresultcard/Title/Root"
      style={{
        ...CRC_TYPE_STYLE[step],
        ...crcTextClampStyle({ lines }),
        minWidth: 0,
      }}
    >
      {children}
    </span>
  );
}
